var $ = require('jquery');
var videojs = require('video.js');
var options = require('./video-options');
var init = require('./video-init');

require('videojs-contrib-hls');

/**
 * Opens video player in modal window.
 *
 * Usage:
 *   var videoModal = new VideoModal;
 *   videoModal.setup(playButton);
 *
 */
module.exports = function () {

    this.setup = function (playButton) {

        playButton = (typeof playButton !== 'string' && playButton instanceof $) ? playButton : $('.'+playButton);

        /**
         * Set-up bindings to initialise the video player on demand.
         *
         * Each video attachment has it's own modal with the markup needed by videojs to reproduce it. But for the
         * modal to behave properly, before opening we need to clone it and attach it to the body.
         */
        playButton.click(function() {
            var modalClone = $(this).siblings('#video-player-modal').clone();

            modalClone.appendTo('body');
            modalClone.modal();

            setupPlayer(modalClone.find('video'));

            /**
             * When the modal is closed we want to completely remove the player from the page, remembering where it stopped
             * so the video can be restarted at the same point if the modal is opened again.
             */
            modalClone.on('hidden.bs.modal', function () {
                var playerId = modalClone.find('.modal-content').children().attr('id');
                var player = videojs.getPlayers()[playerId];

                if (!player.ended()) {
                    updateCurrentTime(playerId, player.currentTime());
                } else {
                    updateCurrentTime(playerId, 0);
                }

                player.dispose();
                modalClone.remove();
            });
        });

    }

    /**
     * Initialises videojs inside the cloned modal appended to the body.
     *
     * To prevent conflicts with the original video, the clone's id is prefixed before initialising the player. The
     * playback starting point is set based on the data-start attribute of the original video element.
     *
     * video -> The video element inside the cloned modal
     */
    var setupPlayer = function(video) {
        // Prefix video id to differentiate clone from original
        video.attr('id', 'modal-' + video.attr('id'));

        var player = init(video.attr('id'), options);

        player.currentTime(video.attr('data-start'));
    };

    /**
     * Updates the attribute data-start of the original video element, so playback can be resumed if the video is
     * opened again.
     *
     * Finds the original video by removing the 'modal-' prefix.
     *
     * playerId -> The player's ID inside the modal
     * currentTime -> Time where the video was stopped
     */
    var updateCurrentTime = function(playerId, currentTime) {
        // Remove prefix to get the original video's ID
        var videoId = '#' + playerId.replace('modal-', '');

        $(videoId).attr('data-start', currentTime);
    };
}
